// extracted by mini-css-extract-plugin
export default {"root":"GYABX","icon-discount":"_3Sbel","iconDiscount":"_3Sbel","btn-show-discounts":"_2NwI1","btnShowDiscounts":"_2NwI1"};